import { render, staticRenderFns } from "./value-selector.vue?vue&type=template&id=64b474bb&scoped=true&"
import script from "./value-selector.vue?vue&type=script&lang=js&"
export * from "./value-selector.vue?vue&type=script&lang=js&"
import style0 from "./value-selector.vue?vue&type=style&index=0&id=64b474bb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b474bb",
  null
  
)

export default component.exports